export default function ($translate) {
    return {
        KEYS: {
            ACTIVATED: 'ACTIVATED',
            EMAIL_SENT: 'EMAIL_SENT',
            EMAIL_LINK_INACTIVE: 'EMAIL_LINK_INACTIVE',
            NOT_ACTIVATED: 'NOT_ACTIVATED'
        },
        LABELS: {
            ACTIVATED: $translate.instant('user.Yes'),
            EMAIL_SENT: $translate.instant('user.No (e-mail sent)'),
            EMAIL_LINK_INACTIVE: $translate.instant('user.No (e-mail link inactive)'),
            NOT_ACTIVATED: $translate.instant('user.No')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/activationStatus/index.js